// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"292":"4bc94c1b","509":"32968267","659":"32968267","672":"ed6d7edc"}[chunkId] + ".css";
};